import React from 'react';
import styled from 'styled-components';
import {mediaTablet, mediaUnderLaptop} from "src/styles/mediaQuery";

interface LNBViewProps {
    dotRefs: React.RefObject<(HTMLDivElement | null)[]>;
    totalSections: number;
}

function LNBView({ dotRefs, totalSections }: LNBViewProps) {
    const dotItems = Array(totalSections).fill(null).map((_, index) => (
        <ListItem key={index}>
            <Dot ref={el => {
                if (dotRefs.current) {
                    dotRefs.current[index] = el;
                }
            }} className="dot" />
        </ListItem>
    ));

    return (
        <LNBWrapper>
            <List className="lnb">
                {dotItems}
            </List>
        </LNBWrapper>
    );
}

export default LNBView;

const LNBWrapper = styled.nav`
  position: fixed;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  ${mediaUnderLaptop}{
    display: none;
  }
  ${mediaTablet}{
    display: none;
  }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  position: relative;
  margin-bottom: 30px;
  &:last-child{
    margin-bottom: 0;
  }
`;

const Dot = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--black-6);
  position: relative;
  z-index: 10;
`;